/** Epic 6 — CSV export for carrier dispute submission. */
export function ExportPage() {
  return (
    <div>
      <p className="text-text-2 text-sm">Export — Epic 6 implementation pending.</p>
    </div>
  );
}
